import { render, staticRenderFns } from "./SliderElement.vue?vue&type=template&id=e04cbd16&scoped=true&"
import script from "./SliderElement.vue?vue&type=script&lang=ts&"
export * from "./SliderElement.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e04cbd16",
  null
  
)

export default component.exports